import { createApiClient } from './api';
import { ClickUpTask, ClickUpDoc } from '../types/clickup';

const createClickUpClient = (apiKey: string) => {
  // In production, always use the proxy path
  const baseURL = '/api/clickup';
  const client = createApiClient(baseURL, apiKey);
  return client;
};

export const fetchTaskDetails = async (taskId: string, apiKey: string): Promise<ClickUpTask> => {
  const client = createClickUpClient(apiKey);
  
  try {
    const response = await client.get(`/api/v2/task/${taskId}`);
    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('Falha inesperada ao buscar detalhes da tarefa');
  }
};

export const fetchDocDetails = async (
  docId: string,
  pageId: string,
  workspaceId: string,
  apiKey: string
): Promise<ClickUpDoc> => {
  const client = createClickUpClient(apiKey);

  try {
    const response = await client.get(
      `/api/v3/workspaces/${workspaceId}/docs/${docId}/pages/${pageId}`,
      {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      }
    );

    if (!response.data) {
      throw new Error('Documento não encontrado');
    }

    return {
      id: docId,
      doc_id: response.data.doc_id || docId,
      parent_page_id: response.data.parent_page_id || '',
      workspace_id: Number(workspaceId),
      name: response.data.name || 'Sem título',
      content: response.data.content || '',
      date_created: response.data.date_created || Date.now(),
      date_updated: response.data.date_updated || Date.now(),
      avatar: response.data.avatar,
      creator_id: response.data.creator_id,
      deleted: response.data.deleted,
      date_edited: response.data.date_edited,
      edited_by: response.data.edited_by,
      archived: response.data.archived,
      protected: response.data.protected,
      presentation_details: response.data.presentation_details
    };
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('Falha inesperada ao buscar detalhes do documento');
  }
};